<script setup>
import Icon from './Icon.vue';

defineOptions({ name: 'DsBadge' });

defineProps({
  tone: { type: String, default: 'neutral' },
  variant: { type: String, default: 'soft' },
  icon: { type: String, default: null },
  mono: { type: Boolean, default: false }
});
</script>

<template>
  <span :class="['ds-badge', `ds-badge--${tone}`, `ds-badge--${variant}`, { 'is-mono': mono }]">
    <span
      v-if="icon === 'dot'"
      class="ds-badge__dot"
    />
    <Icon
      v-else-if="icon"
      :name="icon"
      :size="11"
      :stroke="2"
    />
    <slot />
  </span>
</template>
